import { FC } from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import classNames from 'classnames';

import { RichLabelProps } from 'components/Shared/JabraLabel';
import { RadioButtonListFieldProps } from 'src/types/radioButtonList';

const RadioButtonList: FC<RadioButtonListFieldProps> = (props) => {
  const { field, value, onChange, errors, tracker } = props;
  const {
    model: { items, title, richTitle, cssClass, required },
    valueField,
  } = field;

  const hasAnyError = !!errors?.length;
  const formDesignerClasses = cssClass?.trim();
  const isRequired = !!required;

  const FieldValidationErrors = props.fieldValidationErrorsComponent as FC;
  const Label = props.labelComponent as FC<RichLabelProps>;
  const hasLabel = !!Label && (title || richTitle);
  const selectedValue = value ?? '';

  const radioItemClassName = classNames(
    'min-w-6 max-w-12 aspect-square flex-1 rounded-md md:rounded-xl border-2 text-center text-sm font-semibold text-black transition-colors',
    hasAnyError
      ? 'border-error bg-error/20 data-[state=checked]:border-error data-[state=checked]:bg-error/20'
      : 'border-gray-400 bg-white data-[state=checked]:bg-yellow'
  );

  return (
    <>
      {hasLabel && <Label {...props} component="legend" />}
      <fieldset className={formDesignerClasses} aria-label={title}>
        <RadioGroup.Root
          name={valueField.name}
          required={isRequired}
          aria-required={isRequired}
          value={selectedValue}
          onValueChange={(selectedItemValue) => {
            onChange(valueField.name, selectedItemValue, true, []);
          }}
          className="flex gap-2 md:gap-3 justify-between pt-2"
        >
          {items.map((item, index) => {
            const id = valueField.id + index;
            return (
              <RadioGroup.Item
                key={item.itemId}
                id={id}
                value={item.value}
                className={radioItemClassName}
                onFocus={() => {
                  tracker.onFocusField(field, item.value);
                }}
                onBlur={() => {
                  tracker.onBlurField(field, item.value, errors);
                }}
              >
                {item.text}
              </RadioGroup.Item>
            );
          })}
        </RadioGroup.Root>
      </fieldset>

      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};

export default RadioButtonList;
